import React, { useState, useEffect, useMemo, useRef } from 'react'
import { DebounceInput } from 'react-debounce-input';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import { assignBusinessList } from '../Controller/SupportUserController';
import ScaleLoader from "react-spinners/ScaleLoader";


function ViewBusinessDetailsModalContent(props) {
    const [businessList, setBusinessList] = useState([]);
    const [assignBusinessOffset, setAssignBusinessOffset] = useState(0);
    const [assignBusinessLimit, setAssignBusinessLimit] = useState(10);
    const [hasMoreAssignBusinessList, setHasMoreAssignBusinessList] = useState(true)
    const [searchValue, setSearchValue] = useState('');
    const assignBusinessContentRef = useRef(true);
    const [pageRefresh, setPageRefresh] = useState(false);
    const [assignBusinessStatus, setAssignBusinessStatus] = useState(false);
    const [clearglobalbookingSearchData, setClearGlobalbookingSearchData] = useState(false);

    //initially assign business list fn
    useEffect(() => {
        if (assignBusinessContentRef.current) {
            assignBusinessContentRef.current = false;
            assignBusinessListApiFn();
        }
    }, []);

    //list reload fn
    const loadGrid = () => {
        setAssignBusinessOffset(0)
        setAssignBusinessLimit(12)
        setBusinessList([])
        setPageRefresh(true);
    }

    //business list search handle change
    const handleSearchValue = (e) => {
        if (searchValue.trim() != e.target.value.trim()) {
            if ((e.target.value).trim() != "") {
                setSearchValue(e.target.value)
            } else {
                setSearchValue("")
                setClearGlobalbookingSearchData(true)
            }
        }
    }

    //search value change useeffect call
    useEffect(() => {
        if (searchValue != "") {
            loadGrid();
        }
    }, [searchValue])

    //after clear search data this useefect call
    useEffect(() => {
        if (clearglobalbookingSearchData) {
            loadGrid();
        }
    }, [clearglobalbookingSearchData])


    //search cross button onclick fn
    const clearSearchValue = () => {
        setSearchValue("")
        setAssignBusinessOffset(0)
        setAssignBusinessLimit(12)
        setBusinessList([])
        setClearGlobalbookingSearchData(true)
    }

    //scroll : get more data
    const getNextData = () => {
        if (assignBusinessOffset > 0) {
            assignBusinessListApiFn()
        }
    }

    //refresh the assign business list
    useEffect(() => {
        if (pageRefresh) {
            assignBusinessListApiFn();
        }
    }, [pageRefresh])

    //business list get api dataset formatting
    const formattingAssignBusinessListDataSetFn = (csvDownload = false) => {
        let filters = {};
        let filter_op = {};
        let globalQueryParamshash = {};
        if (!csvDownload) {
            globalQueryParamshash["limit"] = assignBusinessLimit.toString();
            globalQueryParamshash["offset"] = assignBusinessOffset.toString();
        }
        if (csvDownload) {
            globalQueryParamshash["type"] = "csv"
        }
        if (searchValue.trim() !== "") {
            globalQueryParamshash['search_attr'] = searchValue.trim();
            filter_op = Object.assign(filter_op, { "search_attr": "substring" });
        }

        if (Object.keys(filter_op).length > 0) {
            filters["filter_op"] = JSON.stringify(filter_op);
        }
        filters['filters'] = JSON.stringify(globalQueryParamshash);

        return filters;
    }

    //assign business list get api 
    const assignBusinessListApiFn = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let promise = new Promise((resolve, reject) => {
            setAssignBusinessStatus(false)
            loaderStateTrue();
            let filters = formattingAssignBusinessListDataSetFn();
            let id = props.supportUserId;
            assignBusinessList(filters, id).then((response) => {
                if (response.success) {
                    resolve(response)
                } else {
                    setAssignBusinessStatus(true)
                }
                loaderStateFalse();
                setPageRefresh(false);
                setClearGlobalbookingSearchData(false)
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {

                }
                loaderStateFalse();
                setAssignBusinessStatus(true)
                if (error.message == "Network Error") {
                }
            });

        })
        promise.then((res) => {
            if (res.total > 0 || res.data.UserOrgBranchRoleRelation.length > 0) {
                setHasMoreAssignBusinessList(true)
                if (assignBusinessOffset <= res.total) {
                    let tempOffset = assignBusinessOffset + assignBusinessLimit
                    setAssignBusinessOffset(tempOffset)
                    let tempAllBookingRoomData = businessList.slice()
                    const finalBookingRoomData = tempAllBookingRoomData.concat(res.data.UserOrgBranchRoleRelation)
                    setTimeout(() => {
                        setBusinessList(finalBookingRoomData)
                        setAssignBusinessStatus(true)
                    }, 500)
                } else {
                    setHasMoreAssignBusinessList(false)
                    setTimeout(() => {
                        setAssignBusinessStatus(true)
                    }, 500)

                }
                if (res.data.UserOrgBranchRoleRelation.length == 0) {
                    setHasMoreAssignBusinessList(false)
                    setTimeout(() => {
                        setAssignBusinessStatus(true)
                    }, 500)
                }
            } else {
                setHasMoreAssignBusinessList(false)
                setTimeout(() => {
                    setAssignBusinessStatus(true)
                }, 500)
            }


        })

    }

    //assign business list card ui
    const BusinessCard = ({ business }) => {
        return (
            <div className="media businessCardBox">
                <div className="media-left">
                    <i className="fa fa-home" aria-hidden="true"></i>
                </div>
                <div className="media-body">
                    {business.hasOwnProperty('org_name') && business.org_name ? <h5>
                        <OverlayTrigger overlay={<Tooltip className="my-custom-tooltip">{business.hasOwnProperty('org_name') && business.org_name ? business.org_name : ""}</Tooltip>}>
                            {business.org_name.length > 50 ?
                                <span>{(business.org_name).substring(0, 47) + "..."}</span>
                                : <span>{business.org_name}</span>}
                        </OverlayTrigger>
                    </h5> : <h5></h5>}
                    {/* <p>{business.hasOwnProperty('user_type') && business.user_type && business.user_type == "agent" ? <span className='agency'>Agency</span> : <span className='hotel'>Hotel</span>}</p> */}
                </div>
            </div>
        );
    };


    useEffect(() => {
    }, [businessList])


    return (
        <div className="modalinnerbody">
            <form id="busunessList">
                <div className="searchBoxBusunessList">
                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                    <DebounceInput
                        minLength={2}
                        debounceTimeout={500}
                        onChange={handleSearchValue} // Update search handler
                        placeholder="Search..."
                        value={searchValue} // Bind value to search input
                        autoComplete="off"
                    />
                    {searchValue.trim() !== "" ? (
                        <button type="button" className="btn btn-link dropclosebtn" onClick={clearSearchValue}>
                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" alt="Clear" />
                        </button>
                    ) : null}
                </div>
            </form>
            <div id="scrollableDiv" className="scrollableDiv" style={{ overflowY: "auto", position: 'relative' }}>
                <InfiniteScroll
                    dataLength={businessList.length}
                    next={getNextData}
                    hasMore={hasMoreAssignBusinessList}
                    loader={<div className="text-center"></div>}
                    scrollableTarget="scrollableDiv"
                >
                    <div className='businessCardBoxes'>
                        {businessList.map((business, index) => (
                            <BusinessCard key={index} business={business} />
                        ))}
                    </div>
                </InfiniteScroll>
            </div>
        </div>
    );
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}


export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(ViewBusinessDetailsModalContent));
